export default "__VITE_ASSET__D79weI8r__"